import { labText, labToHex } from '../../utils/culture/colour';

/*
 * A colour the server measured: its numbers, with a swatch beside them that only
 * shows what they mean. The numbers are what's read, never the colour alone.
 */
export default function ColourReadout({ lab, testId }) {
  if (!lab) return null;
  return (
    <span data-testid={testId} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span aria-hidden="true" style={{ ...swatchStyle, background: labToHex(lab) }} />
      <bdi dir="ltr">{labText(lab)}</bdi>
    </span>
  );
}

const swatchStyle = { display: 'inline-block', width: 12, height: 12, borderRadius: 3, flex: 'none', border: '1px solid var(--c-border-strong)' };
